import { useState, useEffect } from 'react'
import { VITE_API_BASE } from '../config/apiConfig'

const API = VITE_API_BASE

export default function InviteManagement() {
  const [tab, setTab] = useState('invites')
  const [invites, setInvites] = useState([])
  const [users, setUsers] = useState([])
  const [loading, setLoading] = useState(false)
  const [showCreate, setShowCreate] = useState(false)
  const [form, setForm] = useState({ phone: '', name: '', role: 'partner', trial_days: 7 })

  useEffect(() => {
    loadData()
  }, [tab])

  const loadData = async () => {
    setLoading(true)
    try {
      if (tab === 'invites') {
        const res = await fetch(`${API}/invite/list`)
        const data = await res.json()
        if (data.success) setInvites(data.data?.list || [])
      } else {
        const role = tab === 'partners' ? 'partner' : tab === 'channels' ? 'channel' : tab === 'institutions' ? 'institution' : 'base'
        const res = await fetch(`${API}/invite/users?role=${role}`)
        const data = await res.json()
        if (data.success) setUsers(data.data?.list || [])
      }
    } catch (err) {
      console.error('加载失败:', err)
    }
    setLoading(false)
  }

  const createInvite = async () => {
    if (!form.phone) return alert('请输入手机号')
    
    try {
      const res = await fetch(`${API}/invite/create`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form)
      })
      const data = await res.json()
      if (data.success) {
        alert(`邀请链接：${data.data.inviteLink}`)
        setShowCreate(false)
        setForm({ phone: '', name: '', role: 'partner', trial_days: 7 })
        loadData()
      } else {
        alert(data.error)
      }
    } catch (err) {
      alert('创建失败')
    }
  }

  const resetPassword = async (phone) => {
    if (!confirm(`确定重置 ${phone} 的密码？`)) return
    
    try {
      const res = await fetch(`${API}/invite/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ phone })
      })
      const data = await res.json()
      if (data.success) {
        alert(`新密码：${data.data.tempPassword}\n请告知用户并提醒修改密码`)
      } else {
        alert(data.error)
      }
    } catch (err) {
      alert('重置失败')
    }
  }

  const copyLink = (code) => {
    const link = `${window.location.origin.replace('/cms', '')}/invite.html?code=${code}`
    navigator.clipboard.writeText(link)
    alert('链接已复制')
  }

  const roleNames = {
    partner: '合伙人',
    channel: '渠道商',
    institution: '机构',
    base: '基地',
    headquarters: '总部'
  }

  const statusColors = {
    pending: '#faad14',
    used: '#52c41a',
    expired: '#ff4d4f'
  }

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ fontSize: 20, marginBottom: 20 }}>📨 邀请管理</h2>

      {/* 标签页 */}
      <div style={{ display: 'flex', gap: 8, marginBottom: 24 }}>
        {[
          { key: 'invites', name: '邀请管理', icon: '📨' },
          { key: 'partners', name: '合伙人', icon: '🤝' },
          { key: 'channels', name: '渠道商', icon: '🏪' },
          { key: 'institutions', name: '机构', icon: '🏫' },
          { key: 'bases', name: '基地', icon: '📍' }
        ].map(t => (
          <button
            key={t.key}
            onClick={() => setTab(t.key)}
            style={{
              padding: '8px 16px',
              border: 'none',
              borderRadius: 6,
              cursor: 'pointer',
              background: tab === t.key ? '#722ed1' : '#f5f5f5',
              color: tab === t.key ? '#fff' : '#666',
              fontWeight: tab === t.key ? 'bold' : 'normal'
            }}
          >
            {t.icon} {t.name}
          </button>
        ))}
      </div>

      {/* 邀请管理 */}
      {tab === 'invites' && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 20 }}>
            <h3>邀请列表</h3>
            <button
              onClick={() => setShowCreate(true)}
              style={{
                padding: '8px 20px',
                background: '#722ed1',
                color: '#fff',
                border: 'none',
                borderRadius: 6,
                cursor: 'pointer',
                fontWeight: 'bold'
              }}
            >
              + 创建邀请
            </button>
          </div>

          {showCreate && (
            <div style={{ background: '#f5f5f5', padding: 20, borderRadius: 8, marginBottom: 20 }}>
              <h4 style={{ marginBottom: 16 }}>创建新邀请</h4>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr auto', gap: 12 }}>
                <input
                  type="text"
                  placeholder="手机号"
                  value={form.phone}
                  onChange={e => setForm({...form, phone: e.target.value})}
                  style={{ padding: 10, borderRadius: 6, border: '1px solid #ddd' }}
                />
                <input
                  type="text"
                  placeholder="姓名（选填）"
                  value={form.name}
                  onChange={e => setForm({...form, name: e.target.value})}
                  style={{ padding: 10, borderRadius: 6, border: '1px solid #ddd' }}
                />
                <select
                  value={form.role}
                  onChange={e => setForm({...form, role: e.target.value})}
                  style={{ padding: 10, borderRadius: 6, border: '1px solid #ddd' }}
                >
                  <option value="partner">合伙人</option>
                  <option value="channel">渠道商</option>
                  <option value="institution">机构</option>
                  <option value="base">基地</option>
                </select>
                <select
                  value={form.trial_days}
                  onChange={e => setForm({...form, trial_days: parseInt(e.target.value)})}
                  style={{ padding: 10, borderRadius: 6, border: '1px solid #ddd' }}
                >
                  <option value="7">试用7天</option>
                  <option value="14">试用14天</option>
                  <option value="30">试用30天</option>
                </select>
                <div style={{ display: 'flex', gap: 8 }}>
                  <button
                    onClick={createInvite}
                    style={{
                      padding: '10px 20px',
                      background: '#52c41a',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 6,
                      cursor: 'pointer'
                    }}
                  >
                    发送邀请
                  </button>
                  <button
                    onClick={() => setShowCreate(false)}
                    style={{
                      padding: '10px 20px',
                      background: '#999',
                      color: '#fff',
                      border: 'none',
                      borderRadius: 6,
                      cursor: 'pointer'
                    }}
                  >
                    取消
                  </button>
                </div>
              </div>
            </div>
          )}

          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                <th style={{ padding: 12, textAlign: 'left' }}>手机号</th>
                <th style={{ padding: 12, textAlign: 'left' }}>姓名</th>
                <th style={{ padding: 12, textAlign: 'left' }}>角色</th>
                <th style={{ padding: 12, textAlign: 'left' }}>状态</th>
                <th style={{ padding: 12, textAlign: 'left' }}>创建时间</th>
                <th style={{ padding: 12, textAlign: 'left' }}>操作</th>
              </tr>
            </thead>
            <tbody>
              {invites.map(invite => (
                <tr key={invite.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: 12 }}>{invite.phone}</td>
                  <td style={{ padding: 12 }}>{invite.name || '-'}</td>
                  <td style={{ padding: 12 }}>{roleNames[invite.role] || invite.role}</td>
                  <td style={{ padding: 12 }}>
                    <span style={{ color: statusColors[invite.status], fontWeight: 'bold' }}>
                      {invite.status === 'pending' ? '待注册' : invite.status === 'used' ? '已注册' : '已过期'}
                    </span>
                  </td>
                  <td style={{ padding: 12 }}>{invite.created_at}</td>
                  <td style={{ padding: 12 }}>
                    {invite.status === 'pending' && (
                      <button
                        onClick={() => copyLink(invite.code)}
                        style={{
                          padding: '4px 12px',
                          background: '#1890ff',
                          color: '#fff',
                          border: 'none',
                          borderRadius: 4,
                          cursor: 'pointer',
                          marginRight: 8
                        }}
                      >
                        复制链接
                      </button>
                    )}
                  </td>
                </tr>
              ))}
              {invites.length === 0 && (
                <tr>
                  <td colSpan={6} style={{ padding: 40, textAlign: 'center', color: '#999' }}>
                    暂无数据
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* 用户列表 */}
      {tab !== 'invites' && (
        <div style={{ background: '#fff', borderRadius: 8, padding: 24 }}>
          <h3>{roleNames[tab === 'partners' ? 'partner' : tab === 'channels' ? 'channel' : tab === 'institutions' ? 'institution' : 'base']}列表</h3>
          
          <table style={{ width: '100%', borderCollapse: 'collapse', marginTop: 20 }}>
            <thead>
              <tr style={{ background: '#fafafa' }}>
                <th style={{ padding: 12, textAlign: 'left' }}>手机号</th>
                <th style={{ padding: 12, textAlign: 'left' }}>姓名</th>
                <th style={{ padding: 12, textAlign: 'left' }}>角色</th>
                <th style={{ padding: 12, textAlign: 'left' }}>注册时间</th>
                <th style={{ padding: 12, textAlign: 'left' }}>操作</th>
              </tr>
            </thead>
            <tbody>
              {users.map(user => (
                <tr key={user.id} style={{ borderBottom: '1px solid #f0f0f0' }}>
                  <td style={{ padding: 12 }}>{user.username}</td>
                  <td style={{ padding: 12 }}>{user.name || '-'}</td>
                  <td style={{ padding: 12 }}>{roleNames[user.role] || user.role}</td>
                  <td style={{ padding: 12 }}>{user.created_at}</td>
                  <td style={{ padding: 12 }}>
                    <button
                      onClick={() => resetPassword(user.username)}
                      style={{
                        padding: '4px 12px',
                        background: '#faad14',
                        color: '#fff',
                        border: 'none',
                        borderRadius: 4,
                        cursor: 'pointer'
                      }}
                    >
                      重置密码
                    </button>
                  </td>
                </tr>
              ))}
              {users.length === 0 && (
                <tr>
                  <td colSpan={5} style={{ padding: 40, textAlign: 'center', color: '#999' }}>
                    暂无数据
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}
